const charCodeZero = "0".charCodeAt(0);
const charCodeNine = "9".charCodeAt(0);

function isDigitCode(value: string): boolean {
  const n = value.charCodeAt(0);

  return n >= charCodeZero && n <= charCodeNine;
}

export function getSemanticVersionNumber(target: string): Array<number> {
  const result: Array<number> = [];
  let currentNumber = "";

  for (const char of target) {
    if (isDigitCode(char)) {
      currentNumber += char;
    } else {
      if (currentNumber !== "") {
        result.push(Number(currentNumber));
        currentNumber = "";
      }
    }
  }

  if (currentNumber !== "") {
    result.push(Number(currentNumber));
  }

  return result.slice(0, Math.min(3, result.length));
}

export function isVersionGreaterThanOther(
  target: string,
  other: string,
  allowEqual: boolean
) {
  const targetSemanticVersionNumber = getSemanticVersionNumber(target);
  const otherSemanticVersion = getSemanticVersionNumber(other);

  let index = 0;

  for (const targetVersionPart of targetSemanticVersionNumber) {
    if (index >= otherSemanticVersion.length) {
      return true;
    }

    const otherVersionPart = otherSemanticVersion[index];

    if (targetVersionPart > otherVersionPart) {
      return true;
    } else if (targetVersionPart < otherVersionPart) {
      return false;
    }

    index++;
  }

  return allowEqual;
}
